import type { FC, ReactElement } from "react"

import { useTranslation } from "react-i18next"

import { browserHistory } from "@/3514/constants"
import { buildCssClassName } from "@/3514/utils"
import type { TEmptyCallback } from "@/shared/types/functions"
import { Chevron } from "@/svgs"

import "./styles.scss"

interface IProps {
    className?: string
    onClick?: TEmptyCallback
}

const BaсkButton: FC<IProps> = ({ className, onClick = undefined }: IProps): ReactElement => {
    const { t } = useTranslation()

    const handleClickBack: TEmptyCallback = (): void => {
        browserHistory.back()
        onClick?.()
    }

    return (
        <button className={buildCssClassName("btn back-button", { [className]: className })} onClick={handleClickBack}>
            <Chevron /> <span>{t("common.back")}</span>
        </button>
    )
}

export default BaсkButton
